export default class LeggereNUmeri {

    //Prende formato Decimal128 di MongoDb e restituisce stringa "41,65" (da mostrare a frontend)
    static lavoraDecimal128 (numero: any) {
        const numeroLavorato = parseFloat((numero as any).$numberDecimal).toFixed(2).replace(".", ",");
        return numeroLavorato; 
    }

}